import { LoadingEllipsis, PageTitle } from '@gplibraries/react/components';
import { useLogger, useConfig } from '@gplibraries/react/hooks';
import { useSearchParams } from 'react-router';
import { useEffect } from 'react';

export default function RviRedirect() {

  const logger = useLogger();
  const [params] = useSearchParams();
  const rviHost = useConfig('rviHost')

  useEffect(() => {
    const allowedIsysValues = ['D','L','T','G']
    const isys = params.get('isys')?.toUpperCase();

    if (!isys || !allowedIsysValues.includes(isys)) {
      const error = new Error('An invalid isys value was provided.');
      logger.logError(error,{
        source: 'RviRedirect',
        isys: isys
      })
      throw error;
    }

    // Create the form to execute the post request and redirect

    const formInputData = [
      { type: 'hidden', name: 'rqstyp', value: 'security7'},
      { type: 'hidden', name: 'host', value: rviHost},
      { type: 'hidden', name: 'isys', value: isys},
      { type: 'hidden', name: 'deltyp', value: 'P'},
    ]

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `https://${rviHost}/pgms/rvimain.pgm`;

    // Add form inputs from input data
    formInputData.forEach(input => {
      const element = document.createElement('input');
      element.type = input.type;
      element.name = input.name;
      element.value = input.value;
      form.appendChild(element);
    })

    // append form element and submit
    document.body.appendChild(form);
    form.submit();

  }, []);


  return (
    <>
      <PageTitle>Redirecting to RVI</PageTitle>

      <div>
        You are being redirected<LoadingEllipsis/>
      </div>

    </>
  );
}